import React from 'react';
import CSSModules from 'react-css-modules';
import style from './text.scss';

const Text = ({ children, style, color = 'default', size = 'default', align = 'default' }) => (
  <p styleName={`root color-${color} size-${size} align-${align}`} style={style}>
    {children}
  </p>
);

export default CSSModules(Text, style, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/common/Text.js